import arch from '../../../../assets/images/marketing_Agent/architecture.webp';
import { Pill, Section } from './ui';
const phases = [['PHASE 01', 'LOCAL', '1 – 3'], ['PHASE 02', 'PROVINCIAL', '4 – 5'], ['PHASE 03', 'NATIONAL', '6 – 8'], ['PHASE 04', 'INTERNATIONAL', '9'], ['APEX PINNACLE', 'GLOBAL', '10']];
export default function NetworkIntro() {
  return (
    <Section>
      <div className="d-flex flex-wrap align-items-center gap-3 mb-4">
        <Pill icon="circle-fill" cls="bg-soft text-blue border border-primary-subtle">Selectezi marketing agent program</Pill>
        <span className="fw-bold t-sm"><i className="bi bi-patch-check text-gold me-2" />From Local Connector to Global Ambassador</span>
      </div>
      <div className="row g-5 align-items-center">
        <div className="col-lg-6">
          <h2 className="fw-bolder t-xxl lh-1 mb-4">BUILD YOUR NETWORK<br /><span className="text-blue">BUILD YOUR RANK</span><br /><span className="text-gold">BUILD YOUR OPPORTUNITY</span></h2>
          <p className="t-lg text-muted2">Connect real users, local shops, and premier commercial businesses to SELECTEZI. Progress through 10 prestige Star levels, scale across city and provincial borders, and unlock continuous performance earning opportunities.</p>
          <div className="d-flex flex-column align-items-start gap-3 my-4">
            <button className="btn bg-blue text-white fw-bold rounded-3 px-4 py-3">Become a Marketing Agent <i className="bi bi-rocket-takeoff ms-2" /></button>
            <button className="btn btn-outline-secondary bg-white text-navy fw-bold rounded-3 px-4 py-3">Explore the 10 Star Journey <i className="bi bi-search ms-2" /></button>
          </div>
          <hr />
          <div className="t-xs fw-bold text-muted2 text-uppercase">Execution trajectory</div>
          <div className="fw-bold t-sm">
            <span className="text-blue">CONNECT</span> → <span className="text-blue">GROW</span> → <span className="text-gold">RANK</span> → <span className="text-blue">EARN</span> → LEAD
          </div>
        </div>
        <div className="col-lg-6">
          <div className="card-soft p-3 p-md-4">
            <div className="d-flex justify-content-between align-items-center mb-3 t-xs fw-bold text-uppercase">
              <span><i className="bi bi-circle-fill text-blue me-2" />Selectezi global architecture</span>
              <span className="bg-white shadow-sm rounded-pill px-3 py-1"><i className="bi bi-coin text-gold me-1" />Multi-Node Active Hub</span>
            </div>
            <img src={arch} alt="" className="img-fluid rounded-3 w-100" />
          </div>
        </div>
      </div>
      <hr className="my-5" />
      <p className="text-center t-xs fw-bold text-muted2 text-uppercase">Progressive territory expansion</p>
      <div className="row g-3 row-cols-2 row-cols-lg-5">
        {phases.map(([p, n, s], i) => (
          <div className="col" key={n}>
            <div className={`card-soft text-center p-3 h-100 ${i === 4 ? 'bg-navy text-white' : ''}`}>
              <div className={`t-xs fw-bold ${i === 4 ? 'text-gold' : 'text-muted2'}`}>{p}</div>
              <div className="fw-bold">{n}</div>
              <div><span className={`badge ${i === 4 ? 'bg-navy2 text-gold' : i === 2 ? 'bg-soft text-gold' : 'bg-soft text-blue'}`}>★ {s}</span></div>
            </div>
          </div>
        ))}
      </div>
    </Section>
  );
}
